import classNames from 'classnames';
import {
  Field2 as Field,
} from 'vibeguide';
import Grid from '@mui/material/Grid';

function SegmentCPM({
  className,
  style,
  cpm = 0,
  cpmType = '',
  currencyCode = null,
  disableInput = false,
  onUpdate = () => {},
}) {
  const onChange = (e) => {
    const {
      target: {
        name,
        value,
      },
    } = e;

    onUpdate({
      [name]: value,
    });
  };

  const onChangeCurrency = ({
    name,
    value,
  }) => {
    onUpdate({
      [name]: value,
    });
  };

  return (
    <div
      className={classNames('SegmentCPM', className)}
      style={style}
    >
      <Grid className="row" spacing={2} container>
        <Grid size={12}>
          <Field
            type="select"
            label="CPM Type"
            name="cpmType"
            value={cpmType}
            options={[
              {
                label: '',
                value: '',
              },
              {
                label: 'Fixed',
                value: 'fixed',
              },
            ]}
            disabled
            tabIndex={29}
            testId="segment-cpm-type-select"
            onChange={onChange}
            required
          />
        </Grid>

        <Grid size={12}>
          <Field
            type="currency"
            label="CPM"
            name="cpm"
            value={cpm}
            currencyProps={{
              currencyCode,
            }}
            disabled={disableInput}
            tabIndex={30}
            testId="segment-cpm-input"
            required
            onChange={onChangeCurrency}
          />
        </Grid>
      </Grid>
    </div>
  );
}

export default SegmentCPM;
